import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";
import StaffForm from "../../components/StaffForm";
import { compose, withHandlers } from "recompose";
import WithFetchStaff from "../WithFetchStaff/index";
import { actions } from "../../modules/staffs";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

const UpdateStaff = ({
  submittingStaff,
  failSubmitStaff,
  onSubmit,
  currentStaff
}) => {
  return (
    <div className="content">
      <Row>
        <Col xs={12} sm={12} md={12} lg={12}>
          <div>
            <h3>Update Staff Member</h3>
            <StaffForm
              currentStaff={currentStaff}
              submittingStaff={submittingStaff}
              failSubmitStaff={failSubmitStaff}
              onSubmit={onSubmit}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

const mapStateToProps = state => ({
  submittingStaff: state.staffs.submittingStaff,
  failSubmitStaff: state.staffs.failSubmitStaff
});

const mapDispatchToProps = {
  updateStaff: actions.updateStaff,
  setCurrentStaff: actions.setCurrentStaff
};

UpdateStaff.propTypes = {
  submittingStaff: PropTypes.bool.isRequired,
  failSubmitStaff: PropTypes.string,
  onSubmit: PropTypes.func.isRequired
};

export default compose(
  WithFetchStaff,
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withHandlers({
    onSubmit: ({
      currentDealer,
      currentStaff,
      updateStaff,
      setCurrentStaff,
      history: { push }
    }) => data => {
      updateStaff({
        dealer_id: currentDealer.id,
        staff_id: currentStaff.id,
        data
      }).then(staff => {
        push("/staff");
        setCurrentStaff(null);
      });
    }
  })
)(UpdateStaff);
